module.exports = __webpack_public_path__ + "static/b1-rtj2-02d1c03da734e3be1197f70ed6c5da73.jpg";